import { render } from "./CheckmarkItem.vue?vue&type=template&id=5e26d94c&scoped=true"
import script from "./CheckmarkItem.vue?vue&type=script&lang=js"
export * from "./CheckmarkItem.vue?vue&type=script&lang=js"

import "./CheckmarkItem.vue?vue&type=style&index=0&id=5e26d94c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e26d94c"]])

export default __exports__